(function (root) {
'use strict';
const tiers = Object.freeze([10000, 25000, 40000]);
const duration = 10 * 60 * 1000;
const campaignStart = Date.parse('2026-11-01T00:00:00+01:00');
const campaignEnd = Date.parse('2026-11-14T00:00:00+01:00');
const thresholds = { cloth: 10000, oil: 25000 };

function purchaseAmount(items, giftVariantIds = []) {
  return items.reduce((total, item) => {
    if (item.gift_card || (item.properties?._black_gift_attempt || item.properties?._black_gift_cart_v2) || giftVariantIds.includes(String(item.variant_id))) return total;
    return total + Math.max(0, Number.isSafeInteger(item.final_line_price) ? item.final_line_price : 0);
  }, 0);
}

function qualifyingAmount(amount) {
  if (!Number.isSafeInteger(amount) || amount < 0) return 0;
  return tiers.find(tier => amount < tier && tier - amount <= 500) ?? amount;
}

function availability(amount, currency = 'CHF') {
  if (currency !== 'CHF' || !Number.isSafeInteger(amount) || amount < 0) return { unlocked: [], limit: 0 };
  amount = qualifyingAmount(amount);
  return { unlocked: Object.keys(thresholds).filter(gift => amount >= thresholds[gift]), limit: amount >= 40000 ? 2 : amount >= 10000 ? 1 : 0 };
}

function reconcile(state, now = Date.now()) {
  const { unlocked, limit } = availability(state.amount, state.currency);
  const expired = false;
  let selected = [...new Set(state.selected)].filter(gift => unlocked.includes(gift) && state.stock?.[gift] !== false);
  if (!state.enrolled || !state.active) selected = [];
  if (selected.length > limit) selected = selected.includes('oil') && limit === 1 ? ['oil'] : selected.slice(0, limit);
  return { ...state, selected, expiresAt: null, expired, unlocked, limit };
}

function select(state, gift, now = Date.now()) {
  const current = reconcile(state, now);
  if (!current.active || !current.enrolled || !current.unlocked.includes(gift) || current.stock?.[gift] === false || current.expired) return current;
  const selected = current.selected.includes(gift)
    ? current.selected.filter(value => value !== gift)
    : current.limit === 1 ? [gift] : [...current.selected, gift];
  return reconcile({ ...current, selected, expiresAt: null }, now);
}

function reactivate(state, now = Date.now()) {
  const current = reconcile(state, now);
  if (!current.active || !current.enrolled || !current.expired || !current.limit) return current;
  return reconcile({ ...current, selected: [], expiresAt: null }, now);
}

function campaignActive(now = Date.now()) {
  return now >= campaignStart && now < campaignEnd;
}

function giftKind(item, products) {
  return Object.keys(products).find(key => String(products[key].id) === String(item.variant_id)) || null;
}
// Return only gift-line changes. Paid products, even matching accessories, stay untouched.
function changes(cart, state, products) {
  const seen = new Set();
  const updates = {};
  for (const item of cart.items) {
    const kind = giftKind(item, products);
    const legacy = item.properties?._black_gift_attempt;
    const marked = item.properties?._black_gift_cart_v2;
    if (!kind && !legacy && !marked) continue;
    const valid = kind && state.selected.includes(kind) && !seen.has(kind)
      && item.final_line_price === 0 && marked === kind;
    if (!valid) updates[item.key] = 0;
    else { seen.add(kind); if (item.quantity !== 1) updates[item.key] = 1; }
  }
  const missing = state.selected.filter(key => !seen.has(key));
  return { updates, missing };
}

const api = { qualifyingAmount, tiers, duration, campaignStart, campaignEnd, purchaseAmount, availability, reconcile, select, reactivate, campaignActive, giftKind, changes };
if (typeof module !== "undefined" && module.exports) module.exports = api;
else root.MisakiBlackGiftSelectionRules = api;
})(typeof window !== "undefined" ? window : globalThis);
